import { render, staticRenderFns } from "./ServicesDetails.vue?vue&type=template&id=69f827c0&scoped=true&"
import script from "./ServicesDetails.vue?vue&type=script&lang=js&"
export * from "./ServicesDetails.vue?vue&type=script&lang=js&"
import style0 from "./ServicesDetails.vue?vue&type=style&index=0&id=69f827c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f827c0",
  null
  
)

export default component.exports